module.exports = __webpack_public_path__ + "img/bkqktg.45db78fe.png";